<!DOCTYPE html>
@if (topUpData$ | async; as data) {
  <div class="main">
    <div class="header">
      <h3>{{ "store-top-up.Credit-top-up" | translate }}</h3>
    </div>
    @if (data) {
      @if (topupData) {
        <swiper-container class="topup-slider" [config]="sliderOptions" (slideChange)="onSlideChange()" #creditData
          (swiper)="onSlideChange()">
          @for (topup of topupData; track topup; let index = $index) {
            <ng-template swiperSlide class="swiper-slide">
              @if (changedCheck(index)) {
                <ion-card>
                  <div>
                    @if (!topup.threshold || topup.threshold != 0.5) {
                      <img class="background-image"
                        src="../../../assets/images/storeToUp/Box.png">
                      }
                      @if (topup.threshold == 0.5) {
                        <img class="background-image"
                          src="../../../assets/images/storeToUp/orangeBox.png">
                        }
                        <img class="circles-stars" src="../../../assets/images/storeToUp/circles&stars.png">
                      </div>
                      <div class="container">
                        @if (creditRefresh?.status==true && topup?.threshold == 0.5) {
                          <div class="checkMark">
                            <img src="../../../assets/images/storeToUp/tickCircleSuccess.png" alt="">
                          </div>
                        }
                        <div class="credit-amount">
                          @if (!topup.threshold) {
                            <div class="amount">
                              {{ currencySymbol
                              }}{{topup?.int_price ?
                              topup?.int_price?.[preferredCurrency] : topup?.price}}
                            </div>
                          }
                          @if (topup.threshold && topup?.threshold == 0.5) {
                            <div class="refresh-img">
                              <img
                                src="https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/credit_topup%2Frefresh.png?alt=media&token=617529bf-0c99-4946-9f3d-de1424c32476"
                                alt="">
                              </div>
                            }
                          </div>
                        </div>
                        @if (!topup.threshold && topup.content.sub_label.length>0) {
                          <div class="offer">
                            <p>{{
                              topup?.content?.sub_label_tr ? topup?.content?.sub_label_tr[selectedLanguage] : topup?.content?.sub_label
                              }}
                            </p>
                          </div>
                        }
                        @if (topup.threshold==0.5) {
                          <div class="offer">
                            <p>{{ topup?.content?.sub_label_tr ? topup?.content?.sub_label_tr[selectedLanguage] :
                              topup?.content?.sub_label }}
                            </p>
                          </div>
                        }
                        @if (topup.threshold == 0.5) {
                          <div class="auto-refresh">
                            <p>{{ "store-top-up.autoRefresh" | translate }}</p>
                          </div>
                        }
                        @for (topup of topupData; track topup; let i = $index) {
                          @if (topup.show_default) {
                            <div class="top-up-benefits-wrapper">
                              @for (desc of topup.int_description; track desc; let i = $index) {
                                <div class="top-up-benefits">
                                  <mat-icon>{{ "store-top-up.check" | translate }}</mat-icon>
                                  <p [innerHTML]="desc"></p>
                                </div>
                              }
                            </div>
                          }
                        }
                        <ng-container>
                          @if (topup.threshold == 0.5 && isCreditRefresh()) {
                            <div class="top-up-benefits-wrapper2">
                              <div class="top-up-benefits">
                                <mat-icon>{{ "store-top-up.check" | translate }}</mat-icon>
                                <p [innerHTML]="gift_Desc"></p>
                              </div>
                            </div>
                          }
                        </ng-container>
                      </ion-card>
                    }
                  </ng-template>
                }
              </swiper-container>
            }
          }
          <div class="btn" [class.btn-in-progress]="autoTopUpActionInProgress">
            <ion-button (click)="navigateToCheckout()" class="top-up-btn" [disabled]="autoTopUpActionInProgress">
              @if (autoTopUpActionInProgress) {
                <ion-spinner name="crescent" class="top-up-spinner"></ion-spinner>
              } @else {
              {{btnTxt==true? (('store-top-up.Top') | translate) :(!creditRefresh || creditRefresh?.status === false ? 'store-top-up.activate' :
              'store-top-up.deactivate') | translate }}
              }
            </ion-button>
          </div>
        </div>
      } @else {
        <ion-skeleton-text animated class="skeleton-loader-header"></ion-skeleton-text>
        <swiper [config]="sliderOptions">
          <ng-template swiperSlide class="swiper-slide">
            <ion-skeleton-text animated class="skeleton-loader-card"></ion-skeleton-text>
          </ng-template>
          <ng-template swiperSlide class="swiper-slide">
            <ion-skeleton-text animated class="skeleton-loader-card"></ion-skeleton-text>
          </ng-template>
        </swiper>
      }

